<template>
  <div class="no-record">
    <div class="fb fb-main-center fb-col">
      <div class="fb fb-main-center">
        <i class="iconfont font-120 c-D1D1D1">&#xe60b;</i>
      </div>
      <div class="font-26">
        {{ content || '当天暂无记录' }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    content: {
      type: String,
      default: '当天暂无记录'
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.no-record {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: rgba(25, 31, 37, 0.28);
  i {
    margin-bottom: 10px;
  }
}
</style>
